<template>
  <div class="shipments-page">
    <page-header :title="$t('Action Center')"></page-header>
    
    <shipblu-card class="p-5">
    <vs-tabs v-model="activeTab" class="tabs-shadow-none" id="profile-tabs" :key="$vs.rtl">
      <vs-tab v-for="item in tabs" :key="item" :label="$t(item)">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <action-center-table />
        </div>
      </vs-tab>
    </vs-tabs>
    </shipblu-card>
  </div>
</template>

<script>
import ActionCenterTable from './components/ActionCenterTable.vue'
import ShipbluCard from '../../layouts/components/ShipbluCard.vue'
import common from '../../assets/utils/common'

export default {
  data () {
    return {
      activeTab: '',
      tabs: ['Awaiting Actions', 'In Progress', 'Awaiting Rezoning'],
      tabsDic: {0: 'awaiting-action', 1: 'in-progress', 2: 'awaiting-rezoning'},
      tabsNameDic: {'awaiting-action': 0, 'in-progress': 1, 'awaiting-rezoning' : 2}
    }
  },
  watch: {
    '$route.params.lang' () {
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: this.tabsDic[this.activeTab]
        }
      }).catch(() => {})
    },
    activeTab () {
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: this.tabsDic[this.activeTab],
          page: this.$route.query.page || 1
        }
      }).catch(() => {})
    }
  },
  components: {
    ActionCenterTable,
    ShipbluCard
  },
  created () {
    this.activeTab = this.tabsNameDic[this.$route.query.tab]
    const merchantData = common.checkMerchantInLocalStorage(this)
    merchantData.then(results => {
      const rtoHoldTab = results.merchantData.blucomm_subscriptions[0].rto_hold
      if (rtoHoldTab) {
        this.tabs.push('RTO Hold')
        this.tabsDic[3] = 'rto-hold'
        this.tabsNameDic['rto-hold'] = 3
      }
    })
  }
}
</script>